import { ApiGetCallDefinition, ApiPostCallDefinition } from './helpers/api-call-definition';
export class ApiCall {
    get(routeName, { secure, ...definition }) {
        return new ApiGetCallDefinition(routeName, definition, 'get', secure || false);
    }
    delete(routeName, { secure, ...definition }) {
        return new ApiGetCallDefinition(routeName, {
            method: 'DELETE',
            ...definition,
        }, 'get', secure || false);
    }
    post(routeName, { secure, ...definition }) {
        return new ApiPostCallDefinition(routeName, definition, 'post', secure || false);
    }
    put(routeName, { secure, ...definition }) {
        return new ApiPostCallDefinition(routeName, {
            method: 'PUT',
            ...definition,
        }, 'post', secure || false);
    }
}
